<template>
  <main class="guests-page">
    <div class="guests-page__head">
      <h1 class="guests-page__title">Impostazioni</h1>
      <router-link to="/home" class="villa-btn villa-btn--ghost">
        <i class="fa-solid fa-arrow-left"></i> Dashboard
      </router-link>
    </div>

    <div class="facility-tabs">
      <button
        v-for="t in tabs"
        :key="t.key"
        class="facility-tab"
        :class="{ 'facility-tab--active': activeTab === t.key }"
        @click="activeTab = t.key"
      >
        <i :class="t.icon"></i>
        <span>{{ t.label }}</span>
      </button>
    </div>

    <CompanySettingsPanel v-if="activeTab === 'company'" />
    <CompanyBankAccountsPanel v-else-if="activeTab === 'bank'" />
    <CatalogImportPanel v-else-if="activeTab === 'catalogs'" />
  </main>
</template>

<script>
import CompanySettingsPanel from "@/components/CompanySettingsPanel.vue";
import CompanyBankAccountsPanel from "@/components/CompanyBankAccountsPanel.vue";
import CatalogImportPanel from "@/components/CatalogImportPanel.vue";

export default {
  name: "SettingsPage",
  components: {
    CompanySettingsPanel,
    CompanyBankAccountsPanel,
    CatalogImportPanel,
  },
  data() {
    return {
      activeTab: "company",
      tabs: [
        {
          key: "company",
          label: "Dati società",
          icon: "fa-solid fa-building-shield",
        },
        {
          key: "bank",
          label: "Conti bancari",
          icon: "fa-solid fa-building-columns",
        },
        {
          key: "catalogs",
          label: "Cataloghi CSV",
          icon: "fa-solid fa-database",
        },
      ],
    };
  },
};
</script>

<style src="@/css/GuestsPage.css" />
<style src="@/css/AppLayout.css" />
